"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createJobListResponse = void 0;

var _modelBuilders = require("../../../../utils/model-builders");

var _genericAsResultHeader = require("../../../../utils/generic-as-result-header");

var _consts = require("../consts");

var _BooleanAsNumber = require("../../../../types/BooleanAsNumber");

var _DataServerDate = require("../../../../types/DataServerDate");

function JobStatus(val) {
  var text = val;
  var code = _consts.IA_JOB_STATUS_TEXT_MAP[val];

  if (val.includes('complete')) {
    code = _consts.IA_JOB_STATUS.ACTIVE;
  } else if (code === undefined) {
    code = _consts.IA_JOB_STATUS.UNKNOWN;
  }

  var progress = _consts.IA_JOB_STATUS_PERCENT[code] ? _consts.IA_JOB_STATUS_PERCENT[code](val) : _consts.IA_JOB_STATUS_PERCENT.DEFAULT;
  return {
    progress: progress,
    code: code,
    text: text
  };
}

var createJobListResponse = function createJobListResponse(raw) {
  return (0, _modelBuilders.parseModel)(raw, {
    result: {
      path: 'ListJobsResult[0]',
      model: _genericAsResultHeader.genericAsResultHeader
    },
    returnedCount: {
      path: 'ReturnedCount[0]',
      type: Number
    },
    response: {
      path: 'JobDataArray[0].JobData',
      model: {
        jobQueueId: {
          type: Number,
          path: 'JobQueueId[0]'
        },
        submittedDate: {
          type: _DataServerDate.DataServerDate,
          path: 'SubmittedDate[0]'
        },
        imageId: {
          type: Number,
          path: 'ImageId[0]'
        },
        macroId: {
          type: Number,
          path: 'MacroId[0]'
        },
        inputAnnotationId: {
          type: Number,
          path: 'InputAnnotationId[0]'
        },
        status: {
          type: JobStatus,
          path: 'Status[0]'
        },
        outputAnnotationId: {
          type: Number,
          path: 'OutputAnnotationId[0]'
        },
        completedDate: {
          type: _DataServerDate.DataServerDate,
          path: 'CompletedDate[0]'
        },
        createMarkup: {
          type: _BooleanAsNumber.BooleanAsNumber,
          path: 'CreateMarkup[0]'
        },
        statusDetails: {
          type: String,
          path: 'StatusDetails[0]'
        },
        userId: {
          type: Number,
          path: 'UserId[0]'
        },
        processingHost: {
          type: String,
          path: 'ProcessingHost[0]'
        },
        preProcess: {
          type: Number,
          path: 'PreProcess[0]'
        },
        macroName: {
          type: String,
          path: 'MacroName[0]'
        },
        imageDataGroupId: {
          type: Number,
          path: 'ImageDataGroupId[0]'
        },
        imageParentId: {
          type: Number,
          path: 'ImageParentId[0]'
        },
        imageParentTable: {
          type: String,
          path: 'ImageParentTable[0]'
        },
        compressedFileLocation: {
          type: String,
          path: 'CompressedFileLocation[0]'
        },
        jobAddedBy: {
          type: String,
          path: 'JobAddedBy[0]'
        },
        userFullName: {
          type: String,
          path: 'UserFullName[0]'
        },
        accessFlags: {
          type: String,
          path: 'AccessFlags[0]' // Not parsing InputParametersXML as it appears to duplicate information already available in annotations
          // TODO: Maybe reconsider? Annotations are basically just drawings; why would this info be there?

        }
      }
    }
  });
};

exports.createJobListResponse = createJobListResponse;


//////////////////
// WEBPACK FOOTER
// ./node_modules/lbs-pi-platform-access/es/data-server/image-analysis/jobs/response-parsers/list-jobs-response.js
// module id = 80
// module chunks = 0